import React from "react";
import styled from "styled-components";
import {shadedBackgroundColour} from "../../../../../style/styleConsts";
import {IDEA_ACTIONS} from "../../authorActions";
import {logAction} from "../../../../../logging/logEvent";
import iconPlus from "../../../../../../images/icon_plus.svg";
import iconPlusInverted from "../../../../../../images/icon_plus_inverted.svg";
import iconMinusInverted from "../../../../../../images/icon_minus_inverted.svg";
import iconMinus from "../../../../../../images/icon_minus.svg";

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;    
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    width: 94px;
    height: 48px;
    flex-grow: 0;
    flex-shrink: 0;
    border-radius: 3px;
    border: solid 1px #dcdbda;
    color: ${props => props.selected ? "#ffffff" : "inherit"};
    background-color: ${props => props.backgroundColour};
`;

const IconImg = styled.img`
    width: 16px;
    height: 16px;
    margin-right: 6px;
`;

const Icon = ({action, isSelectedAction}) => {
    if (action === "close") return null;

    let src;
    if (action.startsWith("minus")) {
        src = isSelectedAction ? iconMinusInverted : iconMinus;
    } else {
        src = isSelectedAction ? iconPlusInverted : iconPlus;
    }
    return <IconImg src={src}/>;
};

export const ControlButton = ({disabled, action, selectedAction, onActionSelected}) => {
    function onClick() {
        if (disabled) return;
        onActionSelected(action);

        logAction({
            type: "QUICK_EDIT_ACTION_SELECTED",
            action
        });
    }

    const isSelectedAction = selectedAction === action;
    const backgroundColour = isSelectedAction ? "#3b7433" :
                             disabled ? shadedBackgroundColour : "#ffffff";
    const icon = <Icon action={action} isSelectedAction={isSelectedAction}/>;

    return <Container className={`t-select-${action}-button`}
                      disabled={disabled}
                      backgroundColour={backgroundColour}
                      selected={isSelectedAction}
                      onClick={onClick}>
        {icon}
        <div>{IDEA_ACTIONS[action]}</div>
    </Container>;
};